
//bind and init css and events (onLoan only, no ajax)
function initEventsOnce()
{
    initEventsOnceCommon();
    homepageBanners();
    initSelect2SearchFocus();
}

//bind and init css and events (onLoan and after ajax)
function initEventsWithReload() {
    initEventsWithReloadCommon();
    newsCarousel();
    hideHoneypot();
    initInputNumberSpinner();
    enableTooltips();
    initPopup();
    initFlashMessages();
    initRegisterReminder();
    initSelect();
    toggleFilter();
    categoryFilter();
    toggleNumber();
    usedin();
    productnav();
    label();
    headerLogin();
    mainMenu();
    categorySidebar();
    likeSelect();
    fixedHeader();
    customerSection();
    productList();
    incart();
    worldShip();
    productProperties();
    lineProperties();
    detailProperties();
    initSupplierCheck();
    productBoxShowMore();
    showAllCategories();
    searchtable();
    initTurnstileForms();
    productbox();
    readMoreToggle();
    initLoadingOverlayForm();
    deliveryList();
}

function initOnErrorPage()
{
    mainMenu();
    fixedHeader();
    initFlashMessages();
}

//close alerts
var hideFlashMessagesTimeout;
function initFlashMessages() {
    clearTimeout(hideFlashMessagesTimeout);
    $(".flashmessage__close").on("click", function () {
        $(this).closest(".flashmessage").remove();
    });
    hideFlashMessagesTimeout = setTimeout(function () {
        $(".flashmessage").not(".noclose").fadeTo(500, 0).slideUp(500, function () {
            $(this).remove();
        });
    }, 10000);
}

function closeAllFlashMessages()
{
    $(".flashmessage").remove();
}

/*-------------------------------------enable CSS---------------------------------------------*/
function enableTooltips()
{
    tippy('[data-tippy-content]', {
        allowHTML: true
    });
}

function hideAllTooltips()
{
    tippy.hideAll();
}

function initPopup(){
    $('.open-popup').magnificPopup({
        type:'inline',
        midClick: true,
        callbacks: {
            beforeOpen: function() {  this.wrap.removeAttr('tabindex') }
        }
    });
}


function initInputNumberSpinner()
{
    $('<div class="quantity-nav"><div class="quantity-button quantity-up"><i class="icon-chevron-up"></i></div><div class="quantity-button quantity-down"><i class="icon-chevron-down"></i></div></div>').insertAfter('.quantity input');
    $('.quantity').each(function() {
        var spinner = jQuery(this),
            input = spinner.find('input[type="number"]'),
            btnUp = spinner.find('.quantity-up'),
            btnDown = spinner.find('.quantity-down');

        btnUp.off('click');
        btnDown.off('click');
        btnUp.on("click", function() { ksPackingStep(input.get(0), 1); });
        btnDown.on("click", function() { ksPackingStep(input.get(0), -1); });
    });
}

// Quantity stepper that respects the packing rule: loose pieces (stock mod packing) may be ordered
// individually, anything else snaps to whole packing units. Plain +/-1 when the input carries no
// data-packing. data-packing / data-loose / data-min are set server-side; min/max attrs are fallbacks.
function ksPackingStep(input, dir) {
    var p = parseInt(input.dataset.packing) || 1;
    var loose = parseInt(input.dataset.loose) || 0;
    var min = parseInt(input.dataset.min);
    if (isNaN(min)) min = parseInt(input.getAttribute('min'));
    if (isNaN(min)) min = 1;
    var max = parseInt(input.getAttribute('max'));
    var v = parseInt(input.value) || min;
    var r = ((v % p) + p) % p;
    var next;
    if (dir > 0) {
        next = (r < loose) ? v + 1 : (Math.floor(v / p) + 1) * p;
        if (!isNaN(max) && next > max) next = v;
    } else {
        next = (r > 0) ? v - 1 : v - p + loose;
        if (next < min) next = min;
    }
    input.value = next;
    $(input).trigger("change");
}

function goTop(speed) {
    if (typeof(speed)==='undefined') speed = 0;
    $('html, body').animate({
        scrollTop: 0
    },speed);
}

function goTopOfElement(target, addOffset, speed) {
    if (typeof(speed)==='undefined') speed = 0;
    if (typeof(addOffset)==='undefined') addOffset = 0;

    var jqueryTarget = $(target);
    if (jqueryTarget.length) {
        $('html, body').stop().animate({
            scrollTop: (jqueryTarget.offset().top - addOffset)
        }, speed);
    }
}

//------------------------------------register reminder------------------------------------//
function registerReminder() {
    return true;
    /*
    if(userLoggedIn) {
        return true;
    }
    var timeLimit = 30;
    var registerReminderCookie = Cookies.get('register-reminder');
    if (registerReminderCookie === undefined) {
        Cookies.set('register-reminder', 0);
    } else if (registerReminderCookie < 0) {
        return true;
    } else if (registerReminderCookie >= timeLimit) {
        Cookies.set('register-reminder', timeLimit);
        $(".site-header__user-reminder").addClass('site-header__user-reminder--active');
        return true;
    } else {
        registerReminderCookie++;
        Cookies.set('register-reminder', registerReminderCookie);
    }

    registerTimeout = setTimeout(function () {
        registerReminder();
    }, 1000);
    */
}

function initRegisterReminder() {
    Cookies.set('register-reminder', -1, { expires: 21 });
    /*
    var $disableButton = $(".site-header__user-reminderclose");
    $disableButton.off('click');
    $disableButton.on('click', function () {
        $(".site-header__user-reminder").removeClass('site-header__user-reminder--active');
        Cookies.set('register-reminder', -1, { expires: 21 });
    });
    */
}

function registerReminderCookieRefresh() {
    if (Cookies.get('register-reminder') !== undefined && Cookies.get('register-reminder') < 0) {
        Cookies.set('register-reminder', Cookies.get('register-reminder'), {expires: 21});
    }
}

function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1) ) + min;
}

//------------------------------------New------------------------------------//
function toggleFilter() {

    $(".site-filter__header-item").off("click");
    $(".site-filter__header-left").off("click");
    $(".site-filter__header-mobile").off("click");

    $( ".site-filter__header-item" ).on( "click", function() {
        toggleFilterItems($(this))
    });

    $(".site-filter__header-left").on ("click",function(){
        $(".site-filter__header-item").toggleClass("site-filter__header-item--show");
        categoryFilterShow($('.site-filter__minimizer'));
    });

    $(".site-filter__header-mobile").on ("click",function(){
        if($(this).parent(".site-filter__header").hasClass("site-filter__header--opened")) {
            toggleFilterItems($('.site-filter__header-item--active'));
        } else {
            $(".site-filter__header-item").addClass("site-filter__header-item--show");
            $(this).parent(".site-filter__header").addClass("site-filter__header--opened");
        }
    });
}

function toggleFilterItems(item)
{
    var number = item.data("number")
    item.siblings().removeClass("site-filter__header-item--active");
    item.addClass("site-filter__header-item--active");
    $(".site-filter__header").removeClass("site-filter__header--opened");

    $(".site-filter__content-item[data-number='" + number +"']").siblings().removeClass("site-filter__content-item--opened");
    $(".site-filter__content-item[data-number='" + number +"']").siblings().addClass("site-filter__content-item--closed");
    $(".site-filter__header-text[data-number='" + number +"']").siblings().removeClass("site-filter__header-text--active");


    $(".site-filter__content-item[data-number='" + number +"']").addClass("site-filter__content-item--opened");
    $(".site-filter__header-text[data-number='" + number +"']").addClass("site-filter__header-text--active");
}

function categoryFilter(){
    $('.site-filter__minimizer').on("click",function(){
        categoryFilterToggle($(this));
    });
}

function categoryFilterToggle(minimizer)
{
    $('.site-filter__content--category').toggleClass("site-filter__content--show");
    minimizer.toggleClass("site-filter__minimizer--opened");
    $(".site-filter__header-left").toggleClass("site-filter__header-left--show");
    $(".site-filter__header-right").toggleClass("site-filter__header-right--show");
}

function categoryFilterShow(minimizer)
{
    $('.site-filter__content--category').addClass("site-filter__content--show");
    minimizer.addClass("site-filter__minimizer--opened");
    $(".site-filter__header-left").addClass("site-filter__header-left--show");
    $(".site-filter__header-right").addClass("site-filter__header-right--show");
}

function toggleNumber(){
    $('.site-filter__content-box  .js-select').on("change" , function(){
        $(this).siblings('.site-filter__content-number').addClass('site-filter__content-number--passed')
    });
}

function initSelect() {
    $(document).ready(function() {
        $('.js-select').select2({
            width: '100%',
            placeholder: function(){
                $(this).data('placeholder');
            }
        });

        $('.js-multiselect').select2({
            width: '100%',
            closeOnSelect: false,
            placeholder: function(){
                $(this).data('placeholder');
            }
        });
        $('.site-skeleton--select, .site-skeleton--select_low').hide();
    });

    $("select.js-multiselect").on('select2:open', function (e) {
        const selectId = $(this).attr('id');

        $(".select2-container--open > .selection").append("<button type='button' class='multiselect-button site-form__line-find' data-select-id='"+selectId+"'><span class='icon-find'></span></button>");
        $(".select2-container--open > .selection").append("<button type='button' class='multiselect-button site-form__line-clear' data-select-id='"+selectId+"'>Vymazat</button>");
        initSelect2CloseButton();
        initSelect2ClearButton();
    });
}

// Select2 4.1.0-rc.0 with jQuery 3.6 does not focus the search field on open (Safari needs the delay)
function initSelect2SearchFocus()
{
    $(document).on('select2:open', function () {
        setTimeout(function () {
            var field = document.querySelector('.select2-container--open .select2-search__field');
            if (field) {
                field.focus();
            }
        }, 100);
    });
}

function initSelect2CloseButton()
{
    $(".multiselect-button.site-form__line-find").on("click", function(){
        $('#'+$(this).data('select-id')).select2('close');
    });
}

function initSelect2ClearButton()
{
    $(".multiselect-button.site-form__line-clear").on("click", function(){
        $('#'+$(this).data('select-id')).val(null).trigger("change");
        $('#'+$(this).data('select-id')).select2('close');
    });
}

// Swiper breakpoints are min-width: 1 slide by default, then 2 from 480px, 3 from 600px, 4 from 1024px
function newsCarousel(){
    document.querySelectorAll('.news-carousel__container:not(.swiper-initialized)').forEach(function (element) {
        new Swiper(element, {
            speed: 300,
            slidesPerView: 1,
            slidesPerGroup: 1,
            navigation: {
                prevEl: element.parentElement.querySelector('.swiper-button-prev'),
                nextEl: element.parentElement.querySelector('.swiper-button-next')
            },
            breakpoints: {
                480: { slidesPerView: 2, slidesPerGroup: 2 },
                600: { slidesPerView: 3, slidesPerGroup: 3 },
                1024: { slidesPerView: 4, slidesPerGroup: 4 }
            }
        });
    });
}

function homepageBanners(){
    document.querySelectorAll('.blog-feed__slider:not(.swiper-initialized)').forEach(function (element) {
        new Swiper(element, {
            loop: true,
            autoplay: { delay: 3000 },
            speed: 300,
            slidesPerView: 1,
            pagination: {
                el: element.querySelector('.swiper-pagination'),
                clickable: true
            },
            breakpoints: {
                480: { slidesPerView: 2 },
                1024: { slidesPerView: 3 }
            }
        });
    });
}

function usedin(){
    $(".togglelink").on("click",function(){
        $(this).toggleClass("active");
        $(this).siblings("ul").toggleClass("toggle--open")
    });

    $(document).ready(function(){
        $(".usedin__buttons .btn:first-child").toggleClass("usedin__buttons-item--active");
        $(".usedin__content .usedin__main:first-child").addClass("usedin__main--opened");
    });

    $(".usedin__buttons-item").on("click", function(){
        $(this).siblings(".btn").removeClass("usedin__buttons-item--active");
        $(this).addClass("usedin__buttons-item--active");


        var number = $(this).data("number");

        $(".usedin__main[data-number='" + number +"']").addClass("usedin__main--opened");
        $(".usedin__main[data-number='" + number +"']").siblings(".usedin__main").removeClass("usedin__main--opened");
    });
}

function productnav(){
    $(".product-nav__item").on("click",function(){
        $(this).siblings().removeClass("product-nav__item--active");
        $(this).addClass("product-nav__item--active");
    });
}

function label(){
    $(document).ready(function(){
        var $input = $ ('.site-form__line--pack input, .site-form__line--pack textarea');

        $input.focus (function () {
            $ (this).parent().addClass ('js-focused');
        }).change (function () {
            $ (this).parent().addClass ('js-focused');
        }).blur (function () {
            var tmpval = $ (this).val ();
            if (tmpval === '') {
                $ (this).parent().removeClass ('js-focused');
            } else {
                $ (this).parent().addClass ('js-focused');
            }
        });

        $input.each (function () {
            var val = $ (this).val ();
            if (val.length > 0) {
                $ (this).parent().addClass ('js-focused');
            }
    });
});

}

function headerLogin(){
    $(".site-header__user-login").off("click");
    $(".site-header__user-login").on("click",function(e){
        e.preventDefault();
        $(".site-header__user-popup").toggleClass("site-header__user-popup--active")
    });
}

function mainMenu(){
    $(".site-nav__title").on("click",function(){
        $(".site-nav__main").addClass("site-nav__main--active")
    });

    $(".site-nav__main-close").on("click",function(){
        $(".site-nav__main").removeClass("site-nav__main--active")
    });

    jQuery.fn.clickOutside = function(callback){
        var $me = this;
        $(document).mouseup(function(e) {
            if ( !$me.is(e.target) && $me.has(e.target).length === 0 ) {
                callback.apply($me);
            }
        });
    };

    $('.site-nav__main').clickOutside(function(){
        $(this).removeClass('site-nav__main--active');
    });

}

function categorySidebar(){
    $(".category-sidebar__item-switch").off("click");
    $(".category-sidebar__heading").off("click");
    $(".category__controls-filters").off("click");
    $(".category-sidebar__close").off("click");

    $(".category-sidebar__item-switch").on("click",function(){
        $(this).parent(".category-sidebar__item-haschild").siblings(".category-sidebar__submenu").toggleClass("category-sidebar__submenu--show");
        $(this).toggleClass("category-sidebar__item-switch--opened");
    });

    $(".category-sidebar__heading").on("click",function(){
        $(this).toggleClass("category-sidebar__heading--noactive")
        $(this).next(".category-sidebar__content").toggleClass("category-sidebar__content--noactive")
    });

    $(".category__controls-filters").on("click",function(){
        $(".category-sidebar").addClass("category-sidebar--active");
        $("body").addClass("fixed");
        $("#site-header__main").addClass("site-header__main--fixed");
        $("#site-header__top").hide();
    });

    $(".category-sidebar__close").on("click",function(){
        closeCategorySidebar();
    });

    $(".filter-close").on("click",function(){
        closeCategorySidebar();
    });

    /*jQuery.fn.clickOutside = function(callback){
        var $me = this;
        $(document).mouseup(function(e) {
            if ( !$me.is(e.target) && $me.has(e.target).length === 0 ) {
                callback.apply($me);
            }
        });
    };

    $('.category-sidebar').clickOutside(function(){
        $(this).removeClass('category-sidebar--active');
        $("body").removeClass("fixed");
    });*/

}

function closeCategorySidebar()
{
    $(".category-sidebar").removeClass("category-sidebar--active");
    $("body").removeClass("fixed");
    $("#site-header__top").show();
    fixHeader();
}

function likeSelect(){
    $(".like-select").off("click");
    $(".like-select").on("click",function(){
        $(this).find(".like-select__submenu").toggleClass("like-select__submenu--active")
    });
}

function fixedHeader(){
    window.onscroll = function() {
        fixHeader();
        toggleSearch();
    };
}

function fixHeader() {
    var header = document.getElementById("site-header__main");
    var sticky = header.offsetTop;
    if (window.pageYOffset > sticky + 2) {
        header.classList.add("site-header__main--fixed");
    } else {
        header.classList.remove("site-header__main--fixed");
    }
}


function toggleSearch() {
    var heroSearch = document.querySelector(".site-search__homepage .site-search__input");
    var search = document.querySelector(".site-search");
    var headerTop = document.querySelector(".site-header__top");

    if (!heroSearch || !search) {
        return;
    }
    var headerOffset = headerTop ? headerTop.offsetHeight : 0;
    var heroSearchBottom = heroSearch.offsetTop + heroSearch.offsetHeight;
    if (window.pageYOffset > heroSearchBottom + 50 + headerOffset) {
        search.style.display = "block";
    } else {
        search.style.display = "none";
    }
}

function showAllCategories(){
    $(".all-categories__item-more").off("click");
    $(".all-categories__item-more").on("click",function(){
        $(this).hide();
        $(".all-categories__item--homepage").toggleClass("all-categories__item--show");
    });
}

function customerSection(){
    $(".get-identity").on("click",function(){
        $(".get-identity__card").toggleClass("get-identity__card--show");
    });

    $(".customer-table td:first-child").on("click",function(){
        $(this).siblings("td").toggleClass("td-open");
        $(this).toggleClass("header-open");
    });

    $(".header-open").on("click",function(){
        $(this).siblings("td").toggleClass("td-open");
        $(this).toggleClass("header-open");
    });

    $('.show-incomplete-items').on('click',function (){

        $('table.customer-table tr.status-complete').hide();
        $('.show-incomplete-items').hide();
        $('.show-all-items').show();
        stipeTableOrder();
    });

    $('.show-all-items').on('click',function (){
        $('.customer-table tr').show();
        $('.show-all-items').hide();
        $('.show-incomplete-items').show();
        stipeTableOrder();
    });

    function stipeTableOrder()
    {
        $("table.customer-table tbody tr.article").removeClass("odd even");
        $("table.customer-table tbody tr.article:visible:odd").addClass("odd");
        $("table.customer-table tbody tr.article:visible:even").addClass("even");
    }

    $('.expand-all-items').on('click',function (){
        $(".customer-table tr.article td:first-child").addClass("header-open");
        $(".customer-table tr.article td:nth-child(n+2)").addClass("td-open");
    });

    $('.pack-all-items').on('click',function (){
        $(".customer-table tr.article td:first-child").removeClass("header-open");
        $(".customer-table tr.article td:nth-child(n+2)").removeClass("td-open");
    });

}

function searchtable(){
    $(".searchtable td:first-child").on("click",function(){
        $(this).siblings("td").toggleClass("td-open");
        $(this).toggleClass("header-open");
    });

    $(".searchtable").on("click",function(){
        $(this).siblings("td").toggleClass("td-open");
        $(this).toggleClass("header-open");
    });
}

function productList(){
    $(".product-smallest__properties-switch").on("click",function(){
        $(this).siblings(".product-smallest__properties-list").toggleClass("product-smallest__properties-list--open");
    });
}

var hideIncartTimeout;
function incart(){
    clearTimeout(hideIncartTimeout);
    $(".js-incartclose").on("click",function(){
        $(".incart").addClass("incart--close");
    });

    hideIncartTimeout = setTimeout(function(){
        // toggle another class
        $('.incart').addClass('incart--close');
    },5000);
}

function worldShip(){
    $(".worldship").hide();
    $(".worldship-control").on("click",function(){
        $(".worldship").toggle();
        $(".worldship-control").toggle();
    });

}

function productProperties(){
    $(".product-item__properties-header").off("click").on("click",function(){
        $(this).siblings(".product-item__properties-content").toggleClass("product-item__properties-content--open");
        $(this).toggleClass("product-item__properties-header--open");
    });
}

function lineProperties(){
    $(".product-line__showall").off("click").on("click",function(){
        $(this).siblings(".product-line__properties").toggleClass("product-line__properties--open");
        $(this).toggleClass("product-line__showall--open");
    });
}

function detailProperties(){
    $(".product-detail__data-showall").off("click").on("click",function(){
        $(this).siblings(".product-detail__data").toggleClass("product-detail__data--open");
        $(this).toggleClass("product-detail__data-showall--open");
    });
}

function readMoreToggle(){
    $(".read-more-text-toggle").off("click").on("click",function(e){
        e.preventDefault();
        var parentDiv = $(this).parents(".read-more-text");
        parentDiv.children(".read-more-text-short").toggle();
        parentDiv.children(".read-more-text-full").toggle();
    });
}

// --- Cloudflare Turnstile (invisible) for the online-availability button ---
// One hidden widget is rendered lazily on first click and re-executed for every click. Its callback
// fills the clicked form's hidden .turnstileToken and submits. Logged-in visitors get an empty
// data-turnstile-sitekey and submit straight away (they are exempt server-side).
var _turnstileSiteKey = null;
var _turnstileWidgetId = null;
var _turnstilePendingForm = null;
var _turnstileLoading = false;
var _turnstilePrefillOnly = false;
var _turnstileWatchdog = null;
// Turnstile gave up (no token in time, script failed, widget error): submit the pending form with
// an empty token and let the server decide - a verified session passes, an unverified visitor gets
// the "please retry" message. Either way a response comes back and the spinner is closed.
var TURNSTILE_WAIT_MS = 15000;

function turnstileSubmitPending(token) {
    if (_turnstileWatchdog !== null) {
        clearTimeout(_turnstileWatchdog);
        _turnstileWatchdog = null;
    }
    if (!_turnstilePendingForm) { return; }
    var f = _turnstilePendingForm;
    _turnstilePendingForm = null;
    f.find('.turnstileToken').val(token);
    // prefill mode (mail form): just stash the token, the normal submit carries it
    if (_turnstilePrefillOnly) { _turnstilePrefillOnly = false; return; }
    naja.uiHandler.submitForm(f[0]);
}

function turnstileArmWatchdog() {
    if (_turnstileWatchdog !== null) { clearTimeout(_turnstileWatchdog); }
    _turnstileWatchdog = setTimeout(function () { turnstileSubmitPending(''); }, TURNSTILE_WAIT_MS);
}

function turnstileRunPending() {
    if (_turnstilePendingForm === null || typeof turnstile === 'undefined') {
        return;
    }
    if (_turnstileWidgetId === null) {
        var holder = document.getElementById('turnstile-holder');
        if (!holder) {
            holder = document.createElement('div');
            holder.id = 'turnstile-holder';
            holder.style.display = 'none';
            document.body.appendChild(holder);
        }
        _turnstileWidgetId = turnstile.render(holder, {
            sitekey: _turnstileSiteKey,
            size: 'invisible',
            action: 'check_stock',
            callback: function (token) { turnstileSubmitPending(token); },
            'error-callback': function () { turnstileSubmitPending(''); },
            'timeout-callback': function () { turnstileSubmitPending(''); },
            'unsupported-callback': function () { turnstileSubmitPending(''); }
        });
    } else {
        turnstile.reset(_turnstileWidgetId);
    }
    turnstile.execute(_turnstileWidgetId);
}

window.onTurnstileReady = function () { turnstileRunPending(); };

function loadTurnstile() {
    if (typeof turnstile !== 'undefined') { turnstileRunPending(); return; }
    if (_turnstileLoading) { return; }
    _turnstileLoading = true;
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=onTurnstileReady';
    s.async = true;
    s.defer = true;
    s.onerror = function () { _turnstileLoading = false; turnstileSubmitPending(''); };
    document.head.appendChild(s);
}

function initSupplierCheck() {
    $('.checkSupplierStock').off('click').on('click',function (e){
        e.preventDefault();
        var $form = $('form.checkSupplierStockForm-'+$(this).data('id'));
        // The Naja spinner starts only with the request; show it now so the Turnstile wait is visible.
        // Every path below ends in a submit, so the spinner extension closes it on 'complete'.
        $('.ajax-loading').show(0);
        // Site key from the button: the control renders it empty for logged-in users and for sessions
        // already verified server-side, so those submit straight away without another Turnstile run.
        var siteKey = $(this).data('turnstile-sitekey');
        if (!siteKey) {
            // Through Naja, not form.submit(): the native submit skips the submit event, so the
            // .ajax form would post as a full page load
            naja.uiHandler.submitForm($form[0]);
            return;
        }
        _turnstileSiteKey = siteKey;
        _turnstilePendingForm = $form;
        _turnstilePrefillOnly = false;
        turnstileArmWatchdog();
        loadTurnstile();
    });
}

function initTurnstileForms() {
    // Mail "notify me" form: pre-fetch a Turnstile token when its popup opens, so the normal
    // (Nette AJAX) submit already carries it. Simpler than intercepting the AJAX submit — the mail
    // form's .ajax is on the button, so Nette would otherwise submit before Turnstile could run.
    $('.send-stock-popup-link').off('click.turnstile').on('click.turnstile', function () {
        if (!window.turnstileSiteKey) { return; }              // logged-in / feature off
        var $form = $('#sendStockEmailForm').find('form');
        if (!$form.length || $form.find('.turnstileToken').val()) { return; }
        _turnstileSiteKey = window.turnstileSiteKey;
        _turnstilePendingForm = $form;
        _turnstilePrefillOnly = true;
        loadTurnstile();
    });
}

function hideHoneypot()
{
    $(".frm-text-hp-important").closest('.site-form__line').addClass('site-form__line-hp');
}

function productBoxShowMore(){
    $(".product-detail__box-more").on("click", function(){
        $(this).siblings(".product-detail__box-list").find(".product-detail__box-item--invisible").toggleClass("product-detail__box-item--hidden");
        $(this).find(".more").toggle();
        $(this).find(".less").toggle();
        $(this).addClass("product-detail__box-more--open");
    });
}

function initLoadingOverlayForm() {
    $('form.show-loading').on("submit", function(e) {
        e.preventDefault();
        if(Nette.validateForm(this)) {
            $('.ajax-loading').show(0);
            this.submit();
        }
    });
}

function productbox(){
    $(".product-detail__pack-text .more").on("click",function(){
        $(this).siblings().show();
        $(this).hide();
    });
}


//------------------------------------ga-opt-out------------------------------------
function gaOptout() {
    Cookies.set('disable-analytics-tools', true, {expires: 365});
    Cookies.set(gaDisableStr, true, {expires: 365});
    window[gaDisableStr] = true;
}

function deliveryList()
{
    document.addEventListener("DOMContentLoaded", function () {
        // Zavře ostatní státy po otevření jednoho
        document
            .querySelectorAll(".dship-container .dship-accordion > details")
            .forEach((details) => {
                details.addEventListener("toggle", function () {
                    if (details.open) {
                        document
                            .querySelectorAll(".dship-container .dship-accordion > details")
                            .forEach((other) => {
                                if (other !== details)
                                    other.open = false;
                            });
                    }
                });
            });

        // Otevírání/uzavírání doprav (původní část)
        document.querySelectorAll(".dship-container .dship-delivery-list").forEach((list) => {
            list.querySelectorAll(".dship-container .dship-delivery-row-expandable").forEach((row) => {
                row.addEventListener("click", function (e) {
                    list.querySelectorAll(".dship-container .dship-delivery-row.open").forEach(
                        (r) => {
                            if (r !== row) {
                                r.classList.remove("open");
                                r.querySelector(
                                    ".dship-container .dship-delivery-expand",
                                ).textContent = "+";
                                r.nextElementSibling.style.display =
                                    "none";
                            }
                        },
                    );
                    row.classList.toggle("open");
                    const detail = row.nextElementSibling;
                    if (row.classList.contains("open")) {
                        row.querySelector(
                            ".dship-container .dship-delivery-expand",
                        ).textContent = "–";
                        detail.style.display = "block";
                    } else {
                        row.querySelector(
                            ".dship-container .dship-delivery-expand",
                        ).textContent = "+";
                        detail.style.display = "none";
                    }
                });
            });
            list.querySelectorAll(".dship-container .dship-delivery-details").forEach(
                (d) => (d.style.display = "none"),
            );
            list.querySelectorAll(
                ".dship-container .dship-delivery-row .dship-delivery-expand",
            ).forEach((e) => (e.textContent = "+"));
        });
    });
}
